
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import CourseItem from "@/components/CourseItem.vue";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import _ from "lodash";
import { CourseLevelEnum, EnumHelper, PaymentTypeEnum } from "@/constants/enum.constant";
import { getToken } from "@/functions/token.function";
import ContentFooter from "@/components/ContentFooter.vue";
import toast from "@/functions/toast.function";

@Component({
  components: {
    CourseItem,
    AppLayout,
    ContentFooter,
  },
  filters,
})
export default class BundleCourseDetail extends Vue {
  @Action("getBundleCourseDetail", { namespace: "bundleCourse" })
  private getBundleCourseDetail: any;
  @Action("getBundleCourseRating", { namespace: "bundleCourse" })
  private getBundleCourseRating: any;
  @Action("buy", { namespace: "payment" })
  private buys: any;

  private bundleCourse: any = null;
  private levels = EnumHelper(CourseLevelEnum);
  private ratings = [];
  private ratingTotal = 0;
  private phone = "+62";
  private paymentType = 0;
  private courseCarousel = {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1200: {
      items: 3,
    },
  };

  private get categories() {
    return _.uniqBy(
      this.bundleCourse?.courses.map((course) => course.category),
      (category: any) => category.id
    );
  }
  private get rating() {
    return {
      value: parseFloat(this.bundleCourse?.rating).toFixed(1),
      floor: Math.floor(parseFloat(this.bundleCourse?.rating)),
      total: _.sum(
        this.bundleCourse?.courses.map((course) => course.ratings_count)
      ),
    };
  }
  private get contentsCount() {
    return _.sum(
      this.bundleCourse?.courses.map((course) => course.contents_count)
    );
  }
  private get level() {
    return _.uniq(this.bundleCourse?.courses.map((course) => course.level))
      .map((lvl) => this.levels.find((value) => value.id === lvl)?.name)
      .join(", ");
  }
  private get instructors() {
    return _.uniqBy(
      this.bundleCourse?.courses
        .map((course) => course.instructors)
        .flat(),
      (instructor: any) => instructor.name && instructor.image
    );
  }
  private get feedbacks() {
    return _.orderBy(this.bundleCourse?.ratings, "value", "desc");
  }

  private get ratingPagination() {
    return {
      perPage: 8,
      currentPage: 1,
      rows: this.ratingTotal,
      items: this.ratings,
    };
  }

  private get areAllCoursesFree() {
    return (
      this.bundleCourse?.courses?.length > 0 &&
      this.bundleCourse.courses.every(
        (course: any) =>
          course.price === 0 ||
          course.offer_price === 0 ||
          course.price === 2 ||
          course.offer_price === 2
      )
    );
  }

  @Watch("$route.params.slug")
  private onSlugChange() {
    this.fetchData();
  }

  private created() {
    this.fetchData();
  }

  private fetchData() {
    this.bundleCourse = null;
    this.getBundleCourseDetail({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.bundleCourse = response.data.data;

        this.getRatingData();
      },
    });
  }

  private getRatingData(page: number = 1) {
    this.getBundleCourseRating({
      params: {
        id: this.bundleCourse?.id,
        page: page || 1,
      },
      success: (response: AxiosResponse) => {
        this.ratings = response.data.data.data;
        this.ratingTotal = response.data.data.total;
      },
    });
  }

  private buy() {
    const token = getToken();

    if (getToken()) {
      if (this.bundleCourse?.id) {
        this.$router.push({
          name: 'checkout',
          params: {
            bundle_course_id: this.bundleCourse?.id,
            price: this.bundleCourse?.price,
            offer_price: this.bundleCourse?.offer_price,
            name: this.bundleCourse?.name,
          },
          query: {
            token: token || '',
          },
        });
      }
    } else {
      this.$router.push({
        name: 'login',
      });
    }
  }

  private goToMyCourses() {
    const token = getToken();
    const paymentTypeValue = PaymentTypeEnum.FREE;

    if (token) {
      if (this.bundleCourse?.id) {
        this.buys({
          params: {
            course_id: this.bundleCourse.id,
            payment_type: paymentTypeValue,
            phone: this.phone,
            // partner_code_id: null, 
          },
          success: (response: AxiosResponse) => {

            try {
              const urls = JSON.parse(response.data.data.url);
              const redirect =
                urls?.desktop_web_checkout_url || urls?.mobile_web_checkout_url;
              if (redirect) {
                switch (this.paymentType) {
                  case PaymentTypeEnum.DANA:
                    window.open(redirect, "_blank");
                    break;
                  default:
                    break;
                }
              }
            } catch (e) {
              console.error("Failed to redirect.", e);
            }

            this.$router.push({
              name: "my-courses",
            });
          },
        });
      }
    } else {
      this.$router.push({
        name: "login",
      });
    }
  }

  private goToMyCourses2() {
    this.$router.push({
      name: "my-courses",
    });
  }

  public handleShare(platform: string) {
    const url = window.location.href;
    let shareUrl = '';

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'x':
        shareUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'telegram':
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(url).then(() => {
          toast.success(this.$t("course_detail_link_copied") as string);
        });
        return;
      case 'share':
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: url,
          }).catch((error) => console.log('Error sharing', error));
        } else {
          toast.error(this.$t("course_detail_share_not_supported") as string);
        }
        return;
      default:
        return;
    }
  }
}
